import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { Userpilot } from 'userpilot';
import { environment } from '@environment/environment';
import { MatDialogModule } from '@angular/material/dialog';
import { UserpilotBeaconStyleService } from './services/userpilot/userpilot-beacon-style.service';

@NgModule({
  imports: [
    CommonModule,
    MatSnackBarModule,
    MatDialogModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  ]
})

export class CoreModule { 
  constructor(private readonly userpilotBeaconStyle: UserpilotBeaconStyleService) {
    Userpilot.initialize(environment.userpilotToken);
    this.userpilotBeaconStyle.apply(() => {
      const primary = this.userpilotBeaconStyle.resolveHostCssVar('--primary-color');
      return `
        #userpilot-resource-centre-beacon,
        .widget-headers,
        .widget-header { background: ${primary} !important; }
      `;
    });
  }
  
}
